/**
 * OWLY CRM - Calificados Leads Data
 * Leads con scoring.total >= 70 y stage <= 3
 */

import { Lead } from '@/types';
import { mockProjects, getUnitDisplay } from '../../projects';

const torreVerdeUnits = mockProjects[0].units;
const bosquesRioUnits = mockProjects[1].units;
const ciudadJardinUnits = mockProjects[2].units;

export const calificadosLeads: Lead[] = [];
